import { UserRole } from "./UserRole";

export type UserShortRef = {
    id: string;
    email: string;
    userName: string;
}

export class User {
    id?: string;
    email: string;
    emailConfirmed: boolean;
    userName: string;
    roles: UserRole[];
    tenantId?: number;
    archivedDate?: Date;

    constructor(
        eMail: string,
        emailConfirmed: boolean,
        userName: string,
        roles: UserRole[],
        archivedDate?: Date
    ) {
        this.email = eMail;
        this.emailConfirmed = emailConfirmed;
        this.userName = userName;
        this.roles = roles;
        this.archivedDate = archivedDate;
    }
    static empty(): User {
        return {
            email: '',
            emailConfirmed: false,
            userName: '',
            roles: [],
        };
    }

    static toRef(u: { id?: string, email: string, userName: string }): UserShortRef {
        return { id: u.id!, email: u.email, userName: u.userName };
    }

}